import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './buttons';
import { Theme, styled } from '@material-ui/core';

type Props = {
  label: string;
  loading: boolean;
  onClick: () => void;
};

const StyledButton = styled(Button)<Theme>(({ theme }) => ({
  display: 'block',
  margin: '2rem auto 0 auto',
  background: theme.palette.common.white,
  border: `.1rem solid ${theme.palette.grey['100']}`,
  borderRadius: theme.config.defaultBorderRadius,
  padding: theme.spacing(0.5, 2),
  transition: theme.config.defaultTransition,
  '&:hover': {
    background: theme.palette.grey['50'],
  },
}));

const StyledLabel = styled('span')<Theme>(({ theme }) => ({
  fontFamily: theme.config.primaryFontFamily,
  fontSize: theme.typography.h4.fontSize,
  fontWeight: 400,
  fontStyle: 'italic',
  color: theme.palette.grey['700'],
  textTransform: 'none',
}));

const GetMoreAssignmentsButton: FC<Props> = ({ label, loading, onClick }) => {
  const { t } = useTranslation();

  return (
    <StyledButton onClick={onClick}>
      <StyledLabel>{loading ? t('shared.loading') : label}</StyledLabel>
    </StyledButton>
  );
};

export default GetMoreAssignmentsButton;
